/**
  * @function evalute - evaluate formCollectionBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const backReferenceIndex = await sourceEvaluator(source.backReferenceIndex);
  if (backReferenceIndex === undefined) {
    return undefined;
  }
  const formTypeIdentifiers = await sourceEvaluator(source.formTypeIdentifiers);
  if (formTypeIdentifiers === undefined) {
    return undefined;
  }
  const sort = (await sourceEvaluator(source.sort)) || [{
    index: 'title',
    ascending: true
  }];
  const {
    id
  } = content;
  if (!id) return undefined;
  const filters = {
    [backReferenceIndex]: [[id]]
  };

  // Match queryFormBehavior's current default page size. Pass `limit` explicitly so
  // sentinel/offset stay correct if that default ever changes. Do not use the 200 max —
  // we force paging with small pages, not larger fetches.
  const pageSize = 20;
  const forms = [];
  let offset = 0;
  let hasMorePages = true;
  while (hasMorePages) {
    const querySource = {
      type: 'queryFormBehavior',
      formTypeIdentifiers,
      sort,
      filters,
      indexes: ['title'],
      // workaround for https://app.clickup.com/t/86dtuvecf
      limit: pageSize,
      offset
    };
    // eslint-disable-next-line no-await-in-loop
    const page = await sourceEvaluator(querySource);
    if (page === undefined) {
      return undefined;
    }
    // queryFormBehavior returns one extra row (limit + 1) as a "has next page" indicator
    hasMorePages = page.length > pageSize;
    forms.push(...(hasMorePages ? page.slice(0, pageSize) : page));
    offset += pageSize;
  }
  const collection = {};
  for (let i = 0; i < forms.length; i += 1) {
    const {
      id: remoteID
    } = forms[i];
    collection[remoteID] = {
      _formRef: remoteID,
      _created: i
    };
  }
  return collection;
};
module.exports = {
  evaluate
};